import { render, staticRenderFns } from "./ModalTaxasCheckout.vue?vue&type=template&id=60837050&scoped=true&"
import script from "./ModalTaxasCheckout.vue?vue&type=script&lang=js&"
export * from "./ModalTaxasCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ModalTaxasCheckout.vue?vue&type=style&index=0&id=60837050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60837050",
  null
  
)

export default component.exports